import { ModalBody, ModalCloseButton, ModalContent, ModalHeader, Text } from "@chakra-ui/react";
import { noop } from "../../../../utils";
import { IAppModalProps } from "./types.ts";

/**
 * Application modal wrapper (desktop).
 * It renders content of every modal window in the app.
 *
 * To show modal use useAppModal hook.
 *
 * @see useAppModal
 */
export function DesktopModalView({ content, header, onClose, block, isBlocked }: IAppModalProps) {
  return (
    <ModalContent>
      <ModalCloseButton color="brand.500" _hover={{ bg: "transparent" }} top="14px" right="14px" />
      <ModalHeader minHeight={header ? "64px" : "0"} display="flex" alignItems="center" justifyContent="center">
        <Text textAlign="center" variant="brand" fontSize="md">{header}</Text>
      </ModalHeader>

      <ModalBody pt={0} pb={6}>
        <>
          {content?.(onClose ?? noop, block ?? noop, isBlocked ?? false)}
        </>
      </ModalBody>
    </ModalContent>
  );
}
